export default {"src":"/_next/static/media/hsr.4b4bd943.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};